import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  getFancyMarketsByEvent,
  addExchangeBet,
  getCurrencyTypeFromToken,
  isFancyMarketSuspended,
} from '../../store';
import './ExchFancyMarketsTable.scss';

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Drawer,
  Button,
  Tabs,
  Tab,
} from '@material-ui/core';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import moment from 'moment';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import { EventDTO } from '../../models/common/EventDTO';
import { FancyMarketDTO } from '../../models/common/FancyMarketDTO';
import API from '../../api';
import Modal from '../../components/Modal/Modal';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonButton, IonIcon } from '@ionic/react';
import FancyBookView from './FancyBookView/FancyBookView';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { ThousandFormatter } from '../../util/stringUtil';
import { CloseOutlined } from '@material-ui/icons';
import { useInterval } from '../../hooks/useInterval';

type StoreProps = {
  eventData: EventDTO;
  fmData: FancyMarketDTO[];
  openBets: UserBet[];
  commissionEnabled: boolean;
  addExchangeBet: (data: PlaceBetRequest) => void;
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  bets: PlaceBetRequest[];
  exposureMap: any;
  fancySuspended: boolean;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  langData: any;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const FMTable: React.FC<StoreProps> = (props) => {
  const {
    eventData,
    fmData,
    bets,
    openBets,
    commissionEnabled,
    addExchangeBet,
    loggedIn,
    exposureMap,
    fancySuspended,
    fetchEvent,
    langData
  } = props;

  const disabledStatus = ['suspended', 'suspended-manually', 'ball_running'];
  const [showBooksModal, setShowBooksModal] = useState<boolean>(false);
  const [fancyBookOutcomeId, setFancyBookOutcomeId] = useState<string>();
  const [fancyBookOutcomeName, setFancyBookOutcomeName] = useState<string>();
  const [fancyCategories, setFancyCategories] = useState<Set<string>>(new Set());
  const fancyCategoriesOrder = [
    { fancyCategory: 'All', langKey: 'all_capital' },
    { fancyCategory: 'sessions', langKey: 'sessions' },
    { fancyCategory: 'wpmarket', langKey: 'wp_market' },
    { fancyCategory: 'extramarket', langKey: 'extra_market' },
    // { fancyCategory: "BALL_BY_BALL_SESSION", label: "BALL BY BALL" },
    { fancyCategory: 'oddeven', langKey: 'odd_even' },
    // { fancyCategory: "THREE_SELECTIONS", label: "XTRA MARKET" },
  ];
  const [tabVal, setTabVal] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  // todo : remove all market limits usage and commented code if limits is working fine
  const [marketLimits, setMarketLimits] = useState<any>({});
  const [filteredFancyMarketsData, setFilteredFancyMarketsData] = useState<FancyMarketDTO[]>([]);

  const fetchBetLimits = async (marketId: string, localMCategory: string) => {
    try {
      const payload = {
        competitionId: eventData.competitionId,
        eventId: eventData.eventId,
        marketId: marketId,
        marketType: 'FANCY',
        outcomeDesc: 'fancy',
        sessionId: marketId,
        sportId: eventData.sportId,
        mcategory: localMCategory,
      };

      let response;
      if (sessionStorage.getItem('jwt_token')) {
        response = await API.post('/bs/fetch-market-limits', payload, {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        });
      } else {
        response = await API.post('/bs/fetch-market-limits', payload);
      }
      if (response.status === 200 && response.data.success) {

        let limits = marketLimits;

        limits[marketId ? marketId : eventData.marketId] = {
          minStake: response.data.limits.minStake,
          maxStake: response.data.limits.maxStake,
          maxOdd: response.data.limits.maxOdd,
        };

        setMarketLimits(marketLimits => {
          return {
            ...marketLimits,
            ...limits
          }
        });

      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    let localFancyCategories = new Set<string>();
    for (const fm of fmData) {
      if (fm?.marketId && !fm?.marketLimits && !marketLimits[fm?.marketId]) {
        //setting a default value and the calling the fetch bet limits 
        //so that fetch market limits is not multiple times for a single market
        marketLimits[fm?.marketId] = {
          minStake: 100,
          maxStake: 100,
          maxOdd: 4
        }
        fetchBetLimits(fm?.marketId, fm?.category);
      }
      localFancyCategories.add(fm.category);
    }
    fmData.map((fm) => localFancyCategories.add(fm.category))
    setFancyCategories(localFancyCategories);
  }, [fmData])

  const handletabs = async (localFancyCategory: string) => {
    setFilteredFancyMarketsData(localFancyCategory === "All" ? fmData : fmData.filter(fm => { return fm.category === localFancyCategory }));
  }

  useEffect(() => {
    handletabs('All')
  }, []);

  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const getFancyMarketsByGroup = (category: string) => {
    return fmData
      .filter((fm) => fm.category === category)
      .sort((a, b) => {
        if (a?.sort - b?.sort != 0) {
          return a?.sort - b?.sort;
        }
        const aDesc = a.marketName;
        const bDesc = b.marketName;
        if (aDesc > bDesc) return 1;
        else if (aDesc < bDesc) return -1;
        return 0;
      });
  };

  return (
    <>
      <div className="fm-table-ctn">
        <div className="fm-table-content table-ctn">
          <TableContainer component={Paper}>
            <Table className="fm-table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={12}>
                    <div className="market-name-cell-head-ctn">
                      <span>
                        {langData?.['fancy']}
                        <IonIcon
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'Fancy',
                              eventTypeID: eventData.sportId,
                            })
                          }
                          className="info-img"
                          src={InfoImg}
                        />
                      </span>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tabs-table-cell" colSpan={12}>
                    <div className="tabs-fancy">
                      {fancyCategories.size > 0 ? (
                        <span
                          className={tabVal === 0 ? 'sel-tab' : 'ind-tab'}
                          onClick={() => {
                            handletabs('All');
                            setTabVal(0);
                          }}
                        >
                          <div>{langData?.['all']}</div>
                        </span>
                      ) : null}
                      {fancyCategoriesOrder.map((fc, index) => {
                        return fancyCategories.has(fc.fancyCategory) ? (
                          <span
                            className={
                              tabVal === index + 1 ? 'sel-tab' : 'ind-tab'
                            }
                            onClick={() => {
                              setTabVal(index + 1);
                              handletabs(fc.fancyCategory);
                            }}
                          >
                            <div>{langData?.[fc.langKey]}</div>
                          </span>
                        ) : null;
                      })}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredFancyMarketsData &&
                  filteredFancyMarketsData.length > 0 ? (
                  <>
                    {fancyCategoriesOrder.map((group) => (
                      <>
                        {filteredFancyMarketsData.filter(
                          (fm) =>
                            fm.category === group.fancyCategory &&
                            fancyCategories.has(group.fancyCategory)
                        ).length > 0 ? (
                          <>
                            <FancyHeaderRow groupName={langData?.[group.langKey]} />
                            {getFancyMarketsByGroup(group.fancyCategory).map(
                              (fMarket, index) => (
                                <FancyMarketRow
                                  eventData={eventData}
                                  fMarket={fMarket}
                                  index={index}
                                  cFactor={cFactor}
                                  loggedIn={loggedIn}
                                  openBets={openBets}
                                  disabledStatus={disabledStatus}
                                  addExchangeBet={addExchangeBet}
                                  setShowBooksModal={() => {
                                    setFancyBookOutcomeId(fMarket.marketId);
                                    setFancyBookOutcomeName(fMarket.marketName);
                                    setShowBooksModal(true);
                                  }}
                                  outcomeOpenBets={openBets.filter(
                                    (b) => b.marketType === 2 &&
                                      b.outcomeId === fMarket.marketId
                                  )}
                                  exposureMap={exposureMap}
                                  bets={bets}
                                  selectedRow={selectedRow}
                                  setSelectedRow={setSelectedRow}
                                  // fetchBetLimits={(mId, mcategory) => fetchBetLimits(mId, mcategory)}
                                  minStake={Math.max(fMarket?.marketLimits?.minStake
                                    ? fMarket?.marketLimits?.minStake
                                    : marketLimits[fMarket?.marketId]
                                      ?.minStake, fMarket.limits.minBetValue)}
                                  maxStake={Math.min(fMarket?.marketLimits?.maxStake
                                    ? fMarket?.marketLimits?.maxStake
                                    : marketLimits[fMarket?.marketId]
                                      ?.maxStake, fMarket.limits.maxBetValue)}
                                  oddLimit={fMarket?.marketLimits?.maxOdd?.toString()
                                    ? fMarket?.marketLimits?.maxOdd?.toString()
                                    : marketLimits[fMarket?.marketId]?.maxOdd}
                                  commissionEnabled={commissionEnabled}
                                  fancySuspended={fancySuspended} langData={langData} />
                              )
                            )}
                          </>
                        ) : null}
                      </>
                    ))}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <div className="fm-table-msg-text">
                        {langData?.['fancy_markets_not_found_txt']}
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Drawer
            anchor={'bottom'}
            open={infoDilalog.launch}
            onClose={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            className="light-bg-title game-rules-drawer web-view"
            title="Rules"
          // size="md"
          >
            <div className="game-rules-header">
              <div className="game-rules-title">{langData?.['game_rules']}</div>
              <div
                className="game-rules-close cursor"
                onClick={() =>
                  setInfoDialog({
                    launch: false,
                    oddsType: null,
                    eventTypeID: null,
                  })
                }
              >
                <CloseOutlined />
              </div>
            </div>
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Drawer>

          <Drawer
            anchor={'bottom'}
            open={infoDilalog.launch}
            onClose={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            className="light-bg-title game-rules-drawer mob-view"
            title={langData?.['rules']}
          // size="md"
          >
            <div className="game-rules-header">
              <div className="game-rules-title">{langData?.['game_rules']}</div>
              <div
                className="game-rules-close cursor"
                onClick={() =>
                  setInfoDialog({
                    launch: false,
                    oddsType: null,
                    eventTypeID: null,
                  })
                }
              >
                <CloseOutlined />
              </div>
            </div>
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Drawer>

          <Modal
            open={showBooksModal}
            closeHandler={() => {
              setShowBooksModal(false);
              setFancyBookOutcomeId(null);
            }}
            customClass="fancy-book-dialog"
            title="Book List"
            size="sm"
          >
            <FancyBookView
              fancyBookOutcomeId={fancyBookOutcomeId}
              exposureMap={
                exposureMap &&
                  exposureMap &&
                  exposureMap[`${fancyBookOutcomeId}:${fancyBookOutcomeName}`]
                  ? exposureMap[`${fancyBookOutcomeId}:${fancyBookOutcomeName}`]
                  : {}
              }
            />
          </Modal>
        </div>
      </div>
    </>
  );
};

type FancyHeaderRowProps = {
  groupName: string;
};
const FancyHeaderRow: React.FC<FancyHeaderRowProps> = (props) => {
  const {
    groupName
  } = props;

  const tableFields = [
    {
      key: 'groupName',
      Label: groupName,
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'odds-no',
      Label: 'No',
      className: 'odds-cell-head odds-no-cell',
      align: 'center',
    },
    {
      key: 'odds-yes',
      Label: 'Yes',
      className: 'odds-cell-head odds-yes-cell',
      align: 'center',
    },
    {
      key: 'odds-no',
      Label: '',
      className: 'odds-cell-head limits-cell book-btn-cell',
      align: 'center',
    },
    {
      key: 'limits',
      Label: '',
      className: 'odds-cell-head limits-cell web-view',
      align: 'center',
    }
  ];

  return (
    <TableRow className="header-row">
      {tableFields.map((tF, index) => (
        <TableCell
          key={tF.key + index}
          align={tF.align === 'left' ? 'left' : 'center'}
          className={tF.className}
        >
          {tF.key === 'odds-no' || tF.key === 'odds-yes' ? (
            <div className={tF.key.toLowerCase() + '-cell'}>{tF.Label}</div>
          ) : (
            tF.Label
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

type FancyMarketRowProps = {
  eventData: EventDTO;
  fMarket: FancyMarketDTO;
  index: number;
  cFactor: number;
  loggedIn: boolean;
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  setShowBooksModal: () => void;
  outcomeOpenBets: UserBet[];
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data) => void;
  openBets: UserBet[];
  exposureMap: any;
  // fetchBetLimits: (mId, mcategory) => void;
  maxStake: number;
  minStake: number;
  oddLimit: string;
  commissionEnabled: boolean;
  fancySuspended: boolean;
  langData: any;
};

const FancyMarketRow: React.FC<FancyMarketRowProps> = (props) => {
  const {
    eventData,
    fMarket,
    index,
    cFactor,
    loggedIn,
    disabledStatus,
    addExchangeBet,
    setShowBooksModal,
    outcomeOpenBets,
    bets,
    selectedRow,
    setSelectedRow,
    openBets,
    exposureMap,
    // fetchBetLimits,
    minStake,
    maxStake,
    oddLimit,
    commissionEnabled,
    fancySuspended,
    langData
  } = props;

  // useEffect(() => {
  //   if (fMarket) {
  //     fetchBetLimits(fMarket.marketId, fMarket.category);
  //   }
  // }, [loggedIn]);

  // useEffect(() => {
  //   if (fMarket) {
  //     const interval = setInterval(() => {
  //       console.log("fmarket: ", fMarket)

  //       fetchBetLimits(fMarket.marketId, fMarket.category);
  //     }, 5000);
  //     return () => clearInterval(interval);
  //   }
  // }, [fMarket.marketId]);

  const isFancySuspended = (fMarketSuspended: boolean) => {
    return fancySuspended === true ? true : fMarketSuspended;
  }

  return (
    <TableRow key={'row-' + index}>
      <TableCell className="market-name-cell" key={'row-' + index + 'cell-1'}>
        <div className="market fancy-alin-col">
          {fMarket.marketName} {' '}
          {fMarket.commissionEnabled
            // && commissionEnabled 
            ? (
              <span className='blink-commission-fancy'>*</span>
            ) : null}
        </div>
      </TableCell>
      <TableCell className="odds-cell" key={'row-' + index + 'cell-2'}>
        <div className="odds-block">
          <ExchOddBtn
            mainValue={fMarket.layPrice}
            mainValueClass="runs"
            subValue={fMarket.laySize}
            subValueClass="odds"
            oddType="odds-no-cell"
            valueType="fancyMarketOdds"
            disable={
              disabledStatus.includes(fMarket.status.toLowerCase()) ||
              isFancySuspended(fMarket.suspend) === true ||
              moment(eventData.openDate).diff(moment(), 'minutes') > 60 * 24 * 2
            }
            onClick={() => {
              if (!disabledStatus.includes(fMarket.status.toLowerCase()) || isFancySuspended(fMarket.suspend) === true) {
                setSelectedRow(fMarket.marketName + 'FM');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: fMarket.marketId,
                  marketName: fMarket.marketName,
                  marketType: 'FANCY',
                  outcomeId: fMarket.marketId,
                  outcomeDesc: '@ ' + fMarket.layPrice,
                  betType: 'LAY',
                  amount: 0,
                  oddValue: fMarket.laySize,
                  sessionPrice: fMarket.layPrice,
                  oddLimt: oddLimit,
                  minStake: minStake,
                  maxStake: maxStake,
                  mcategory: fMarket.category,
                });
              }
            }}
          />
        </div>
      </TableCell>
      <TableCell className="odds-cell" key={'row-' + index + 'cell-3'}>
        <div className="odds-block">
          <ExchOddBtn
            mainValue={fMarket.backPrice}
            mainValueClass="runs"
            subValue={fMarket.backSize}
            subValueClass="odds"
            oddType="odds-yes-cell"
            valueType="fancyMarketOdds"
            disable={
              disabledStatus.includes(fMarket.status.toLowerCase()) ||
              isFancySuspended(fMarket.suspend) === true ||
              moment(eventData.openDate).diff(moment(), 'minutes') > 60 * 24 * 2
            }
            onClick={() => {
              if (!disabledStatus.includes(fMarket.status.toLowerCase()) ||
                isFancySuspended(fMarket.suspend) === true) {
                setSelectedRow(fMarket.marketName + 'FM');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: fMarket.marketId,
                  marketName: fMarket.marketName,
                  marketType: 'FANCY',
                  outcomeId: fMarket.marketId,
                  outcomeDesc: '@ ' + fMarket.backPrice,
                  betType: 'BACK',
                  amount: 0,
                  oddValue: fMarket.backSize,
                  sessionPrice: fMarket.backPrice,
                  oddLimt: oddLimit,
                  minStake: minStake,
                  maxStake: maxStake,
                  mcategory: fMarket.category,
                });
              }
            }}
          />
        </div>
      </TableCell>
      <TableCell className="odds-cell book-btn-cell" key={'row-' + index + 'cell-4'}>
        <Button
          className="fancy-book-btn"
          onClick={() => {
            if (exposureMap &&
              exposureMap[
              `${fMarket.marketId}:${fMarket.marketName}`
              ]) setShowBooksModal();
          }}
          disabled={!(exposureMap &&
            exposureMap[
            `${fMarket.marketId}:${fMarket.marketName}`
            ])}
        >
          {langData?.['book']}
        </Button>
        <div className="row mob-view mob-bet-limits">
          <div style={{fontSize :'9px'}}>{langData?.['min']}: {minStake ? ThousandFormatter(
            minStake
              ? minStake / cFactor
              : 100, "min"
          ) : 0}</div> <div style={{fontSize :'9px'}}> {langData?.['max']}: {maxStake ?
            ThousandFormatter(
              maxStake
                ? maxStake / cFactor
                : 100, "max"
            ) : 0}</div>
        </div>
      </TableCell>
      <TableCell className="limits-cell web-view">
        <div className="limits-data">
          <div className="row web-view">{langData?.['min']}: {minStake ? ThousandFormatter(
            minStake
              ? minStake / cFactor
              : 100, "min"
          ) : 0} {langData?.['max']}: {
              maxStake ?
                maxStake % 1000 === 0 ?
                  ThousandFormatter(
                    maxStake
                      ? maxStake / cFactor
                      : 100, "max"
                  ) : maxStake
                    ? Math.round(maxStake / cFactor)
                    : 100
                : 0}</div>
          <div className="row mob-view">
            <div>{langData?.['min']}: {minStake ? ThousandFormatter(
              minStake
                ? minStake / cFactor
                : 100, "min"
            ) : 0}</div> <div> {langData?.['max']}: {
              maxStake ?
                maxStake % 1000 === 0 ?
                  ThousandFormatter(
                    maxStake
                      ? maxStake / cFactor
                      : 100, "max"
                  ) : maxStake
                    ? maxStake / cFactor
                    : 100
                : 0}</div>
          </div>
          {/* <div className="row"></div> */}
        </div>
      </TableCell>
      {disabledStatus.includes(fMarket.status.toLowerCase()) ||
        isFancySuspended(fMarket.suspend) === true ? (
        <div className="disabled-odds-cell" key={'row-' + index + 'cell-5'}>
          {fMarket.status.toLowerCase().includes('suspended') || isFancySuspended(fMarket.suspend) === true
            ? 'SUSPENDED'
            : (eventData.sportId != '4' && fMarket.status.includes('BALL_RUNNING')) ? 'SUSPENDED'
            : fMarket.status.replace('_', ' ')}
        </div>
      ) : null}
    </TableRow>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;
  return {
    eventData: getAllMarketsByEvent(
      state.exchangeSports.events,
      eventType.id,
      competition.id,
      event.id
    ),
    fmData: getFancyMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
    fancySuspended: isFancyMarketSuspended(
      state.exchangeSports.secondaryMarketsMap,
      event.id
    ),
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    commissionEnabled: state.common.commissionEnabled,
    langData: state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMTable);
